import React from "react";
import { Switch } from "@/components/ui/switch";
import { CheckinSettingsResponse } from "@/types/booking-checkin-settings";

const Label = ({ children, className }: any) => (
  <label className={`text-2xl font-medium ${className || ""}`}>
    {children}
  </label>
);

interface RoomUpgradeTabProps {
  settings: CheckinSettingsResponse | null;
  setSettings: React.Dispatch<
    React.SetStateAction<CheckinSettingsResponse | null>
  >;
}

export const RoomUpgradeTab = ({
  settings,
  setSettings,
}: RoomUpgradeTabProps) => {
  const updateSetting = (
    key: keyof CheckinSettingsResponse,
    value: CheckinSettingsResponse[keyof CheckinSettingsResponse],
  ) => {
    setSettings((previousSettings) =>
      previousSettings
        ? {
            ...previousSettings,
            [key]: value,
          }
        : previousSettings,
    );
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Switch
          checked={settings?.isShowRoomUpgrade}
          onCheckedChange={(checked) =>
            updateSetting("isShowRoomUpgrade", checked)
          }
        />
        <Label>Upsell - room upgrade</Label>
      </div>
      <div className="flex items-center gap-2">
        <Switch
          checked={settings?.isShowRoomFacilities}
          onCheckedChange={(checked) =>
            updateSetting("isShowRoomFacilities", checked)
          }
        />
        <Label>Room Facilities</Label>
      </div>
    </div>
  );
};
